/**
 *  Initialize filters and pagination for cause/{slug} page
 */

var causeFilters = (function () {
    var pub = {}; // public facing functions

    pub.init = function () {
        var skip = 10;
        var limit = 10;

        function loadMoreArticles() {
            var container = $('#cause-articles');
            var causeSlug = container.data('slug');

            // TODO: Add functionality to add articleType if something is seleted in the dropdown.
            var url = '/causes/' + causeSlug + '?skip=' + skip + '&limit=' + limit;

            $.ajax(url, {
                success: function (data) {
                    if (data.length > 0)
                        skip = skip + 10;

                    container.append(data);
                }
            });
        }

        $('#load-more-articles').on('click', loadMoreArticles);
    }
    return pub;
})();
